import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postLoginData } from "../redux/actions/authActions";
import Loader from "./utils/Loader";
// import SendOTP from './SendOTP';
// import VerifyOTP from './VerifyOTP';
// import ResetPassword from './ResetPassword';
// import ForgotPassword from './ForgotPassword';
import Think5WhysIAmHuman from './Think5WhysIAmHuman';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const LoginForm = ({ redirectUrl }) => {
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [view, setView] = useState('login');
  const [Iamhuman, setIamhuman] = useState(false); 
  const [message, setMessage] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.authReducer);
  const { loading, isLoggedIn } = authState;
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(redirectUrl || "/");
    }
  }, [authState, redirectUrl, isLoggedIn, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateManyFields = (type, data) => {
    const errors = [];

    if (type === "login") {
      if (!data.email) {
        errors.push({ field: "email", err: "Email is required" });
      } else if (!validateEmail(data.email)) {
        errors.push({ field: "email", err: "Invalid email format" });
      }
      if (!data.password || data.password.length < 8) {
        errors.push({
          field: "password",
          err: "Password must be at least 8 characters",
        });
      }
    }

    return errors;
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (Iamhuman) {
      setMessage('Proceed to login...');
    } else {
      setMessage('Please verify you are human before submitting.');
      return;
    }
    const errors = validateManyFields("login", formData);
    setFormErrors({});
    if (errors.length > 0) {
      setFormErrors(
        errors.reduce((total, ob) => ({ ...total, [ob.field]: ob.err }), {})
      );
      return;
    }
    dispatch(postLoginData(formData.email, formData.password));
  };

  const fieldError = (field) => (
    <p
      className={`mt-1 text-red-500 text-sm ${
        formErrors[field] ? "block" : "hidden"
      }`}
    >
      <i className="mr-2 fa-solid fa-circle-exclamation text-red-500"></i>
      <span className="text-red-500">{formErrors[field]}</span>
    </p>
  );

  const handleGoogleLogin = () => {
    // window.location.href = 'http://localhost:3001/auth/google';
  };

  const handleFacebookLogin = () => {
    // window.location.href = 'http://localhost:3001/auth/facebook';
  };

  const handleResetPasswordClick = () => {
    navigate("/resetpassword");
  };

  const handleOtpSent = (mobile) => {
    setView('verifyOtp');
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
};

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-700 p-2">
      <div className="w-full max-w-md p-8 rounded-3xl shadow-xl bg-gradient-to-r from-gray-100 to-gray-300">
        {view === 'login' && (
          <form className="space-y-2">
            {loading ? (
              <Loader />
            ) : (
              <>
                <label className="text-center text-red-800 font-bold text-lg tracking-wide">
                  Welcome Think5Whys User
                </label>
                <div className="mb-2">
                  <label
                    htmlFor="email"
                    className="block text-gray-800 text-sm font-semibold mb-1"
                  >
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    placeholder="youremail@domain.com"
                    onChange={handleChange}
                    className="w-full p-4 border text-black border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600 transition duration-300"
                    style={{ width: '100%'}}
                  />
                  {fieldError("email")}
                </div>

                <div className="mb-2">
                    <label
                        htmlFor="password"
                        className="block text-gray-800 text-sm font-semibold mb-1"
                    >
                        Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative w-full" style={{ width: '250px' }}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            id="password"
                            value={formData.password}
                            placeholder="Your password"
                            onChange={handleChange}
                            className="w-full p-4 border text-black border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600 transition duration-300"
                        />
                        <div
                            className="absolute text-black inset-y-0 right-0 pr-4 flex items-center cursor-pointer"
                            onClick={togglePasswordVisibility}
                        >
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                size="lg"
                            />
                        </div>
                    </div>
                    <div className="text-red-500">{fieldError("password")}</div>
                </div>
                <div className="flex flex-col bg-gray-600 items-center justify-center min-h-[200px] mb-2 rounded-md p-2">
                    <p className="text-center text-xs mt-2 mb-2 !text-yellow-200">
                        Important for security!! To prove you are Human, please hit the boxes in sequence (ie 1, 2, 3, 4, 5 & 6)
                    </p>
                    <p className="text-center mb-2 text-sm !text-cyan-200">
                        In case you face problem in hitting the boxes on your mobile phone, do it in Landscape mode! 
                    </p>
                    <Think5WhysIAmHuman setIamhuman={setIamhuman} />
                    {message && <p className="text-red-600 text-center text-xs">{message}</p>} 
                </div>
                        
                <div className="mb-2">
                  <button
                    type="submit"
                    className="bg-green-600 text-white py-1 rounded-lg font-semibold hover:bg-green-700 transition duration-300 ease-in-out"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>

                <div className="mb-2">
                  <button
                    className="text-blue-800 bg-yellow-200 hover:bg-yellow-300 hover:text-blue-900 text-sm w-full py-1"
                    onClick={handleResetPasswordClick}
                  >
                    Forgot Password? Reset here.
                  </button>
                </div>

                <div className="mb-2 text-center">
                  <Link to="/signup" className="text-blue-600 hover:underline">
                    Don't have an account?{" "}
                    <span className="font-medium">Signup Here</span>
                  </Link>
                </div>

                <div className="space-y-2">
                  <button
                    className="w-full bg-white text-red-600 border border-red-600 py-2 px-4 rounded-lg flex items-center justify-center gap-2 font-semibold hover:bg-red-50 transition duration-300 ease-in-out"
                    disabled
                    onClick={handleGoogleLogin}
                  >
                    <FontAwesomeIcon icon={faGoogle} className="text-red-600" />
                    Login with Google
                  </button>
                  {/* <button
                    className="w-full bg-blue-800 text-white py-2 px-4 rounded-lg flex items-center justify-center gap-2 font-semibold hover:bg-blue-700 transition duration-300 ease-in-out"
                    disabled
                    onClick={handleFacebookLogin}
                  >
                    <FontAwesomeIcon icon={faFacebook} className="text-white" />
                    Login with Facebook
                  </button> */}
                </div>
              </>
            )}
          </form>
        )}

        {/* {view === 'forgotpwd' && (
          <ForgotPassword />
        )} */}

        {/* {view === 'sendOtp' && (
          <ResetPassword />
          // <SendOTP onOtpSent={handleOtpSent} />
        )}

        {view === 'verifyOtp' && (
          <VerifyOTP />
        )} */}
      </div>
    </div>
  );
};

export default LoginForm;
